export default class Slider {
    constructor() {
        window.addEventListener('load', () => {
            this.init();
        });
        window.addEventListener('resize', () => {
            this.init();
        })
    }

    init() {
        let elements = document.querySelectorAll('.slider-wrapper');
        elements.forEach((v) => {
            if (v.currentInterval) {
                clearInterval(v.currentInterval);
            }
            let computedStyle = getComputedStyle(v);
            v.track = v.querySelector('.slider-track');
            v.items = v.querySelectorAll('.slider-item');
            v.itemWidth = 100 / computedStyle.getPropertyValue("--slider-items");
            v.interval = computedStyle.getPropertyValue("--slider-interval");
            v.delay = computedStyle.getPropertyValue("--slider-duration");
            v.arrowPrev = v.querySelector('.slider-arrow-prev');
            v.arrowNext = v.querySelector('.slider-arrow-next');
            v.dotWrapper = v.querySelector('.slider-dot-wrapper');

            v.items.forEach(slide => {
                slide.style.width = `${v.itemWidth}%`;
            });

            if (v.dotWrapper) {
                this.addDots(v);
            }

            this.addEvents(v);

            setTimeout(() => {
                let paddingBottom = parseInt(getComputedStyle(v.track).paddingBottom);
                v.track.style.setProperty('--slider-track-height', `${v.track.getBoundingClientRect().height - paddingBottom}px`)
            }, 300);
        });
    }

    addEvents(element) {
        if (element.interval !== "0") {
            element.currentInterval = setInterval(() => {
                this.nextSlide(element)
            }, element.interval);
        }
        if (element.arrowPrev) {
            element.arrowPrev.addEventListener('click', () => {
                this.prevSlide(element);
            });
        }
        if (element.arrowNext) {
            element.arrowNext.addEventListener('click', () => {
                this.nextSlide(element);
            });
        }
        element.items.forEach(item => {
            if (item.dot) {
                item.dot.addEventListener('click', async () => {
                    this.setItemActive(element, item);
                    while (item !== element.track.firstElementChild) {
                        await this.nextSlide(element);
                    }
                });
            }
        });

        element.addEventListener('touchstart', (e) => {
            element.startX = e.touches[0].clientX;
            element.startY = e.touches[0].clientY;
        });

        element.addEventListener('touchend', (e) => {
            let endX = e.changedTouches[0].clientX;
            let endY = e.changedTouches[0].clientY;

            let deltaX = endX - element.startX;
            let deltaY = endY - element.startY;

            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                if (deltaX > 0) {
                    this.prevSlide(element);
                } else {
                    this.nextSlide(element);
                }
            }
        });
    }

    async prevSlide(element) {
        let lastItem = element.track.children[element.track.children.length - 1];
        lastItem.style.marginLeft = `-${element.itemWidth}%`;
        element.track.insertBefore(lastItem, element.track.firstChild);
        setTimeout(() => {
            lastItem.style.marginLeft = `0`;
            this.setItemActive(element, element.track.children[0]);
        }, 100);
    }

    async nextSlide(element) {
        let firstItem = element.track.children[0];
        firstItem.style.marginLeft = `-${element.itemWidth}%`;
        this.setItemActive(element, element.track.children[1]);
        await this.sleep(element.delay);
        setTimeout(() => {
            element.track.appendChild(firstItem);
            firstItem.style.marginLeft = `0`;
        }, 0);
    }

    addDots(element) {
        element.items.forEach((item, k) => {
            if (item.dot)
                return;
            let dot = document.createElement('div');
            dot.classList.add("slider-dot");
            if (k === 0) {
                dot.classList.add('active');
            }
            item.dot = dot;
            element.dotWrapper.appendChild(dot);
        });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    setItemActive(element, item) {
        element.items.forEach(innerItem => {
            innerItem.dot.classList.remove('active');
        });
        item.dot.classList.add('active');
    }
}
